export default {
	title: 'Indicadores',
	url: 'indicators',
	subtitle:
		"Liste seus indicadores de sucesso e organize-os por categorias — por padrão, as 4 perspectivas do Balanced Scorecard: Financeira, Clientes, Processos internos, Aprendizado e crescimento. A aba Visualização os apresenta como um balanced scorecard, com sua evolução por cenário.",
	no_description: 'Nenhum indicador definido',
	context_worse: 'Negativo',
	context_best: 'Positivo',
	tabs: {
		filters: {
			title: 'Filtros de vista'
		},
		general: {
			title: 'Geral'
		},
		export: {
			title: 'Exportar'
		},
		comments: {
			title: 'Histórico'
		},
		bot: {
			title: 'IA'
		}
	},
	messages: {
		edit_constraint: 'Edição de indicador',
		create_constraint: 'Criar novo indicador'
	},
	onboarding: {
		title: 'Revisão dos indicadores',
		description:
			"Verifique se os indicadores cobrem as categorias do Balanced Scorecard e estão vinculados ao plano de ação."
	}
};
